"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClinicalEventForSickLeaveRequest_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ClinicalEvent_1 = require("./ClinicalEvent");
var SickLeaveRequest_1 = require("./SickLeaveRequest");
var ClinicalEventForSickLeaveRequest_Factory = /** @class */ (function () {
    function ClinicalEventForSickLeaveRequest_Factory() {
    }
    ClinicalEventForSickLeaveRequest_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ClinicalEvent: ClinicalEvent_1.ClinicalEvent_Factory.CreateIncoming(model.ClinicalEvent),
            ClinicalEventId: model.ClinicalEventId,
            SickLeaveRequest: SickLeaveRequest_1.SickLeaveRequest_Factory.CreateIncoming(model.SickLeaveRequest),
            SickLeaveRequestId: model.SickLeaveRequestId,
        };
        return result;
    };
    ClinicalEventForSickLeaveRequest_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ClinicalEvent: ClinicalEvent_1.ClinicalEvent_Factory.CreateOutgoing(model.ClinicalEvent),
            ClinicalEventId: model.ClinicalEventId,
            SickLeaveRequest: SickLeaveRequest_1.SickLeaveRequest_Factory.CreateOutgoing(model.SickLeaveRequest),
            SickLeaveRequestId: model.SickLeaveRequestId,
        };
        return result;
    };
    return ClinicalEventForSickLeaveRequest_Factory;
}());
exports.ClinicalEventForSickLeaveRequest_Factory = ClinicalEventForSickLeaveRequest_Factory;
